// Widget Scripts
import './js/videoWidgetSimpleCustom.js';
import cardWidget from './js/widgets/cardWidget.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import hotButtons from './js/widgets/hotButtons.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import seowidget from './js/widgets/seowidget.js';
import cardWidgetEmail from './js/widgets/cardWidgetEmail.js';
import videoWidgetSecond from './js/widgets/videoWidgetSecond.js';
import cssSponsors from './js/widgets/cssSponsors.js';
import cardWidgetSlider from './js/widgets/cardWidgetSlider.js';
// Custom Theme Scripts

// Custom Theme Scripts
import './js/localjs.js';


// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    cardWidget();
    cardWidgetSlider();
    swiperWidget();
    hotButtons();
    multiScheduleFeature();
    cardWidgetEmail();
    seowidget();
  });
}
$(window).load(function () {

  videoWidget();

  setTimeout(function () {
    videoWidgetSecond();
  }, 1000)

});


// initialize site-wide widgets
$(document).ready(function () {
  cssSponsors();
});